import { Row, Col, Card } from 'react-bootstrap';
import './KPICard.scss';

const KPICard = ({
    title,
    period,
    priorPeriod,
    year,
    priorYear,
    varianceRaw,
    variancePercentage
}) => {
    return (
        <Card className='my-3 mx-2'>
            <Card.Title className='text-center mt-4 mb-0'>{title}</Card.Title>

            <Card.Body>
                {/* PERIOD vs PRIOR PERIOD */}
                <Row className='justify-content-center align-content-center'>
                    <Col xs={6} className="p-2">
                        <div className="month-bg kpi-rectangle float-end rounded">
                            <span className="title">Period</span>
                            <span className="number">{period}</span>
                        </div>
                    </Col>
                    <Col xs={6} className="p-2">
                        <div className="month-bg kpi-rectangle float-start rounded">
                            <span className="title">Prior Period</span>
                            <span className="number">{priorPeriod}</span>
                        </div>
                    </Col>
                </Row>

                {/* YTD vs PRIOR YTD */}
                <Row className='justify-content-center align-content-center'>
                    <Col xs={6} className="p-2">
                        <div className="year-bg kpi-rectangle float-end rounded">
                            <span className="title">Year to date</span>
                            <span className="number">{year}</span>
                        </div>
                    </Col>
                    <Col xs={6} className="p-2">
                        <div className="year-bg kpi-rectangle float-start rounded">
                            <span className="title">PYTD</span>
                            <span className="number">{priorYear}</span>
                        </div>
                    </Col>
                </Row>

                {/* VARIANCE: CYTD vs PY */}
                <Row className='justify-content-center align-content-center'>
                    <Col xs={6} className="p-2">
                        <div className="variance-bg float-end kpi-rectangle rounded">
                            <span className="title">Variance - CY vs. PY</span>
                            <span className='number'>{varianceRaw}</span>
                        </div>
                    </Col>
                    <Col xs={6} className="p-2">
                        <div className="variance-bg float-start kpi-rectangle rounded">
                            <span className="title">% YTD - CY vs. PY</span>
                            <span className='number'>{variancePercentage}</span>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default KPICard;
